import type { TransitionProps } from 'vue'
import type { TransitionFn } from '~/middleware/02.page-transition.global.ts'

export const getDefaultPageTransition: TransitionFn = () => {
  return {
    mode: 'out-in',
    onEnter(el, done) {
      gsap.from(el, { autoAlpha: 0, duration: 0.24, ease: 'none', onComplete: done, onInterrupt: done })
    },
    onLeave(el, done) {
      gsap.to(el, { autoAlpha: 0, duration: 0.15, ease: 'none', onComplete: done, onInterrupt: done })
    },
    onLeaveCancelled(el) {
      gsap.killTweensOf(el)
    },
    onEnterCancelled(el) {
      gsap.killTweensOf(el)
    },
  } satisfies TransitionProps
}
